import { IGetQuery } from 'ets-fe-ng-sdk';
import { environment } from '../../../../environments/environment';
import { EUserType } from '../../../@ngrx/user/user.model';
export const UserActivityEndpointBase = `v1/users/activity/log` as const;
export interface IUADeletionPayload {
  id: number;
  selected: boolean;
}
export type IUASearchObj = Partial<
  IGetQuery<{
    userType: EUserType;
    companyCode: string;
    loggedTimeFrom: string;
    loggedTimeTo: string;
    pageNumber: number;
    pageSize: number;
    pageTitle: string;
    requestMethod: string;
    screen: string;
    sortBy: string;
    sortDirection: string;
    userAgent: string;
    userCode: string;
    userName: string;

    ipAddress: string;
    pageUrl: string;
    activityDescription: string;
  }>
>;
export interface IUASearchResponse {
  id: number;
  userName?: string;
  loggedIn: boolean;
  ipAddress: string;
  loggedTime: string;
  userAgent: string;
  pageUrl?: string;
  screen?: string;
  pageTitle: string;
  activityDescription?: string;
  requestUrl?: string;
  requestMethod?: string;
  companyCode?: string;
  userType?: EUserType;
}
export interface IUserActivity {
  id?: number;
  activityDescription?: string;
  pageTitle?: string;
  pageUrl?: string;
  requestMethod?: string;
  requestUrl?: string;
  screen?: EUA;
}
export class UserActivity implements IUserActivity {
  id!: number;
  activityDescription?: string = undefined;
  pageTitle?: string;
  pageUrl?: string;
  requestMethod!: string;
  requestUrl!: string;
  companyCode?: string;
  userType?: EUserType | null;
  screen?: EUA;
  constructor(data: IUserActivity) {
    if (data) {
      Object.assign(this, data);
      this.activityDescription = (
        codeToDescriptionMap.find((x) => x.key == this.screen)?.value +
        ' ' +
        (this.activityDescription ? `{${this.activityDescription}}` : '')
      )?.trim();
      this.pageUrl = this.pageUrl || location.href;
      // debugger;
      this.pageTitle = this.pageTitle || environment.pageTitle || document.title;
      this.companyCode = environment.userCompanyCode;
      this.screen = this.screen || data['code'];
    }
  }
}
export enum EUA {
  exported = 'export',
  visited = 'visited',
  searched = 'searched',
  downloaded = 'downloaded',
  clicked = 'clicked',
  loggedIn = 'logged_in',
  loggedOut = 'logged_out',
}
const codeToDescriptionMap = [
  { key: EUA.exported, value: 'Exported data' },
  { key: EUA.visited, value: 'User visited new page' },
  { key: EUA.searched, value: 'User performed a search' },
  { key: EUA.downloaded, value: 'User downloaded an item' },
  { key: EUA.clicked, value: 'User clicked on a button' },
  { key: EUA.loggedIn, value: 'User logged in' },
  { key: EUA.loggedOut, value: 'User logged out' },
];
